// extracted by mini-css-extract-plugin
export default {"root":"InternalLoanProgramDetailPage_root__77Jjd","viewButton":"InternalLoanProgramDetailPage_viewButton__gGwTx"};